import { FeatureToggle } from '@ravago/shared/page-data/models/config';

export function hasPermission(permissions: FeatureToggle[], featurePermission: string, defaultValue = false) {
  return permissions.find((permission) => permission.name === featurePermission)?.allowed ?? defaultValue;
}
